import React, { memo, useCallback } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import Button from 'components/App/Button';
import Loading from 'components/App/Loading';

import { LOCATIONS } from 'constants/index';
import INITIAL_VALUE from 'constants/initialValue';
import { currencyFormat } from 'utils/currencyFormat';

import styles from './DataTableLocationDetailPriceType.module.scss';

function DataTableLocationDetailPriceType(props) {
  const {
    isLoadingGetPLacePriceTypes,

    placePriceTypes,

    onOpenModalDeletePlacePriceTypes,
    setPriceId,

    placeId,
  } = props;

  const onDeleteButtonClick = useCallback((id) => () => {
    onOpenModalDeletePlacePriceTypes();
    setPriceId(id);
  }, [onOpenModalDeletePlacePriceTypes, setPriceId]);

  const ButtonType = useCallback((isDefault, id) => {
    if (!isDefault) {
      return (
        <div className="d-flex">
          <Button
            outline
            classes="Action__Button Action__Button__Danger"
            onClick={onDeleteButtonClick(id)}
          >
            Xóa
          </Button>

          <Link to={`${LOCATIONS.LOCATION_DETAIL.EDIT_PRICE_TYPE}?place=${placeId}&id=${id}`}>
            <Button
              outline
              classes="Action__Button Action__Button__Link"
            >
              Chỉnh sửa
            </Button>
          </Link>
        </div>
      );
    }

    return (
      <div className="d-flex">
        <Link to={`${LOCATIONS.LOCATION_DETAIL.EDIT_PRICE_TYPE}?place=${placeId}&id=${id}`}>
          <Button
            outline
            classes="Action__Button Action__Button__Link"
          >
            Chỉnh sửa
          </Button>
        </Link>
      </div>
    );
  }, [onDeleteButtonClick, placeId]);

  const getMealDisplayName = (mealType) => {
    switch (mealType) {
      case 'BREAKFAST':
        return 'Bữa sáng';
      case 'LUNCH':
        return 'Bữa trưa';
      case 'DINNER':
        return 'Bữa tối';
      default:
        return mealType;
    }
  };

  return (
    <>
      <Loading
        loading={isLoadingGetPLacePriceTypes}
        loaderOnPage
      />

      <div className={styles.Component}>
        <Table
          responsive
          className="Table"
        >
          <thead className="Table__Header">
            <tr className="Table__Header__Row">
              <th className="col-md-2 Table__Header__Row__Content">
                Tên loại giá
              </th>

              <th className="col-md-3 Table__Header__Row__Content">Chính sách hủy phòng</th>

              <th className="col-md-3 Table__Header__Row__Content">Loại phòng</th>

              <th className="col-md-2 Table__Header__Row__Content">Bữa ăn bao gồm</th>

              <th className="col-md-2 Table__Header__Row__Content">Doanh thu ròng</th>
            </tr>
          </thead>

          <tbody className="Table__Body">
            {placePriceTypes.map((room) => (
              <tr className="Table__Body__Row" key={room._id}>
                <td className="Table__Body__Row__Content">
                  <p className="TextPrimary">
                    {room.name}
                  </p>

                  <p className="TextSecondary">
                    ID&nbsp;
                    {room._id}
                  </p>

                  <div className="Action">
                    {ButtonType(room.isDefault, room._id)}
                  </div>
                </td>

                <td className="Table__Body__Row__Content">
                  {room.cancelBookingPolicy.freeBeforeDays === 0
                    ? 'Không hoàn hủy'
                    : `Linh động - ${room.cancelBookingPolicy.freeBeforeDays} ngày`}
                </td>

                <td className="Table__Body__Row__Content">
                  {room.rooms.map((type) => (
                    <div key={type._id} className="TypeRoom">
                      {type.name}
                    </div>
                  ))}
                </td>

                <td className="Table__Body__Row__Content">
                  {room.includeMeals.map((mealType) => (
                    mealType !== 'STANDARD' && (
                    <div key={mealType} className="TypeRoom">
                      {getMealDisplayName(mealType)}
                    </div>
                    )
                  ))}
                </td>

                <td className="Table__Body__Row__Content">
                  {currencyFormat({ value: room.netRevenue, currency: 'VNĐ' })}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
}

DataTableLocationDetailPriceType.propTypes = {
  isLoadingGetPLacePriceTypes: PropTypes.bool,

  placePriceTypes: PropTypes.instanceOf(Array),

  onOpenModalDeletePlacePriceTypes: PropTypes.func,
  setPriceId: PropTypes.func,

  placeId: PropTypes.string,
};

DataTableLocationDetailPriceType.defaultProps = {
  isLoadingGetPLacePriceTypes: false,

  placePriceTypes: INITIAL_VALUE.ARRAY,

  onOpenModalDeletePlacePriceTypes: INITIAL_VALUE.FUNCTION,
  setPriceId: INITIAL_VALUE.FUNCTION,

  placeId: '',
};

export default memo(DataTableLocationDetailPriceType);
